/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-lone-blocks */
import { Fragment, useEffect, useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Parallax } from "react-scroll-parallax";
import CalendarRow from "./CalendarRow";
import kanan from "../../../assets/images/icon_home/tangankanan.svg";
import frame from "../../../assets/images/icon_home/Frame.svg";
import kiri from "../../../assets/images/icon_home/tangankiri.svg";
import topCalendar from "../../../assets/images/icon_academic/top-calendar.svg";
import { Calendar } from "react-calendar";
import moment from "moment";
import "./calendar.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import * as api_academic from "../../../core/service/api_academic";
import { removeUser } from "../../../core/feature/user/userSlice";
import { removeBalance } from "../../../core/feature/user/balanceSlice";
import { useAppSelector } from "../../../core/feature/hooks";
import { useTranslation } from "react-i18next";
import { Dialog, Transition } from "@headlessui/react";
import { isDarkColor } from "../../../config/DarkColorChecker";
import CustomApp from "../../../core/models/customApp";

function CalendarAcademik(prop: any) {
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const [activeMonthString, setActiveMonthString] = useState(prop.month);
  const [listEventDay, setListEventDay] = useState<any>([]);
  const language: String = useAppSelector((state) => state.language.language);
  const [show, setShow] = useState(false);
  const [activeYear, setActiveYear] = useState(prop.year);
  const [lang, setLang] = useState<any>(language);
  const [value, onChange] = useState(prop.date);

  const { t } = useTranslation();
  const listEvent = prop.list;

  function getEventInDay(tanggal: any) {
    setShow(true);
    var convTangggal = moment(tanggal).format("YYYY-MM-DD");
    var tanggalAkhir = moment(tanggal)
      .subtract(-1, "days")
      .format("YYYY-MM-DD");
    api_academic
      .getAgenda(convTangggal, tanggalAkhir)
      .then((res: any) => {
        setListEventDay(res.data.content);
      })
      .catch((e: any) => {
        console.log(e, "eror");
      });
  }

  useEffect(() => { }, []);

  return (
    <div className="flex-col h-[850px] shadow rounded-2xl relative flex bg-white">
      <h1 className="font-montserrat m-0 absolute z-50 top-2 left-2 opacity-70 text-2xl font-bold"
      style={{ color: `${isDarkColor(customApp.app_accent_color) ? 'white' : 'black'}` }}>
        {t("HOME.menu.calendarAcademic")}
      </h1>
      <div
        className="w-full flex flex-row relative "
        style={{
          backgroundColor: `${customApp.app_accent_color}`,
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
        }}
      >
        <img
          src={frame}
          className="w-full h-60 bottom-0 relative "
          style={{ top: "28%" }}
          alt=""
        />
        <div className="w-1/2 absolute flex left-0 top-12 -rotate-12">
          <div className="w-52 h-40">
            <img src={kiri} />
          </div>
        </div>

        <div className="w-1/2 absolute flex right-0 top-6">
          <div className="w-52 h-40">
            <img src={kanan} />
          </div>
        </div>
      </div>
      <div className=" rounded-2xl px-4 w-full h-auto relative">
        <div className="w-full rounded ">
          <div className="flex items-center flex-col justify-center mb-4 relative mt-1">
            <div className="text-center font-bold text-xl text-black dark:text-white mt-4">
              {`${activeMonthString} ${activeYear}`}
            </div>
          </div>
          <div className="border-b h-auto pb-4">
            <Calendar
              value={value}
              onChange={onChange}
              nextLabel={null}
              prevLabel={null}
              locale={lang}
              next2Label={null}
              prev2Label={null}
              className={"react-calendar"}
              showNeighboringMonth={false}
              goToRangeStartOnSelect={false}
              showNavigation={false}
              selectRange={false}
              onClickDay={(date) => getEventInDay(date)}
              tileContent={({ activeStartDate, date, view }) => {
                var eventtotal: any[] = [];
                {
                  listEvent.forEach((element: any, index: any) => {
                    if (
                      moment(element.startDate).format("DD-MM-YYYY") <=
                      moment(date).format("DD-MM-YYYY") &&
                      moment(element.endDate).format("DD-MM-YYYY") >=
                      moment(date).format("DD-MM-YYYY") &&
                      moment(element.startDate).format("MM") ===
                      moment(date).format("MM")
                    ) {
                      eventtotal.push(element);
                    }
                  });
                }
                return (
                  <div className="flex flex-row justify-center">
                    {eventtotal.map((e: any, i: any) => {
                      return (
                        <div
                          style={{
                            backgroundColor: e.color,
                            borderRadius: "50%",
                            width: 5,
                            height: 5,
                          }}
                        ></div>
                      );
                    })}
                  </div>
                );
              }}
            />
            <style>
              {`
                .react-calendar__tile--now:enabled:hover {
                  background-color: ${customApp.app_secondary_accent_color};
                  color: ${isDarkColor(customApp.app_secondary_accent_color) ? 'white' : 'black'};
                }
                .react-calendar__tile--now {
                  border-radius: 10px;
                  color: ${isDarkColor(customApp.app_accent_color) ? 'white' : 'black'};
                  background-color: ${customApp.app_accent_color};
                }
              `}
            </style>
          </div>
          <div className=" flex flex-col p-2 rounded-2xl">
            <div className="font-bold ">{t("CUSTOMER.desc")}</div>
            <div className="overflow-y-auto overflow-x-hidden justify-start relative flex-wrap w-full h-[190px] rounded-xl">
              {listEvent.map((item: any, index: any) => {
                return (
                  <div
                    className="flex flex-row relative w-full m-0 items-center"
                    key={index}
                  >
                    <div
                      style={{
                        backgroundColor: item.color,
                        borderRadius: "100%",
                        width: 10,
                        height: 10,
                      }}
                    ></div>
                    <div className="relative flex flex-col h-full top-2 ml-1  justify-center items-center">
                      <p className="font-montserrat text-sm">
                        {item.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <Transition appear show={show} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-20"
          onClose={() => setShow(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto font-montserrat">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    {t("CALENDAR.description")}
                  </Dialog.Title>
                  <div className="mt-2">
                    {listEventDay.length == 0 ? (
                      <div className="relative flex flex-col h-full top-2 ml-1  justify-center items-center">
                        <p className="font-montserrat text-sm">
                          {"Tidak Ada Data"}
                        </p>
                      </div>
                    ) : null}
                    {listEventDay.map((item: any, index: any) => {
                      return (
                        <div
                          className="flex flex-row relative w-full m-1 items-center"
                          key={index}
                        >
                          <div
                            style={{
                              backgroundColor: item.color,
                              borderRadius: "100%",
                              width: 15,
                              height: 15,
                            }}
                          ></div>
                          <div className="relative flex flex-col h-full top-2 ml-1  justify-center items-center">
                            <p className="font-montserrat text-sm">
                              {item.description}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="mt-4 flex gap-2">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                      onClick={() => setShow(false)}
                    >
                      {t("CALENDAR.back")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}

export default CalendarAcademik;
